// @ts-nocheck
import type { Question } from '../types';

export const vehicleHandlingQuestions: Question[] = [
  {
    id: 'q-vh-1',
    topic: 'General',
    question: 'What should you do if your vehicle starts to skid?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-1-vehicle-skidding.jpg',
    options: [
      { id: 'q-vh-1o1', text: 'Brake hard' },
      { id: 'q-vh-1o2', text: 'Ease off the accelerator and steer in the direction you want to go; do not brake sharply' },
      { id: 'q-vh-1o3', text: 'Accelerate to regain grip' }
    ],
    answerId: 'q-vh-1o2',
    explanation: 'Ease off the accelerator. Steer in the direction you want the front of the vehicle to go. Avoid braking hard; it can make the skid worse.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-2',
    topic: 'General',
    question: 'What is "aquaplaning"?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-2-aquaplaning.jpg',
    options: [
      { id: 'q-vh-2o1', text: 'Driving through a car wash' },
      { id: 'q-vh-2o2', text: 'When the tyres lose grip on a wet road and the vehicle slides on a film of water' },
      { id: 'q-vh-2o3', text: 'Using windscreen washer fluid' }
    ],
    answerId: 'q-vh-2o2',
    explanation: 'Aquaplaning is when the tyres lift off the road surface on a layer of water and you lose steering and braking. Ease off the accelerator and do not brake hard.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-3',
    topic: 'General',
    question: 'What should you do if your brakes fail?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-3-brake-failure.jpg',
    options: [
      { id: 'q-vh-3o1', text: 'Switch off the engine immediately' },
      { id: 'q-vh-3o2', text: 'Use the parking brake gradually; change to a lower gear; use engine braking; warn others' },
      { id: 'q-vh-3o3', text: 'Accelerate to get off the road' }
    ],
    answerId: 'q-vh-3o2',
    explanation: 'Apply the parking brake gradually (not suddenly). Change to a lower gear to use engine braking. Use hazard lights and try to steer to a safe place.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-4',
    topic: 'General',
    question: 'When driving on ice or snow, what should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-4-ice-snow-driving.jpg',
    options: [
      { id: 'q-vh-4o1', text: 'Drive at normal speed' },
      { id: 'q-vh-4o2', text: 'Drive slowly and smoothly; avoid sudden braking, acceleration, or steering' },
      { id: 'q-vh-4o3', text: 'Use the highest gear possible' }
    ],
    answerId: 'q-vh-4o2',
    explanation: 'On ice or snow, drive slowly and smoothly. Avoid sudden braking, acceleration, or steering. Use a higher gear to reduce wheel spin.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-5',
    topic: 'General',
    question: 'What should you do if your steering suddenly becomes very heavy?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-5-heavy-steering.jpg',
    options: [
      { id: 'q-vh-5o1', text: 'Speed up to make steering easier' },
      { id: 'q-vh-5o2', text: 'Slow down and stop safely; you may have a puncture or power steering failure' },
      { id: 'q-vh-5o3', text: 'Brake hard' }
    ],
    answerId: 'q-vh-5o2',
    explanation: 'Heavy steering can mean a puncture (front tyre) or power steering failure. Slow down and stop in a safe place. Check tyres and fluid.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-6',
    topic: 'General',
    question: 'What should you do if a tyre blows out at speed?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-6-tire-blowout.jpg',
    options: [
      { id: 'q-vh-6o1', text: 'Brake hard and steer to the left' },
      { id: 'q-vh-6o2', text: 'Hold the steering wheel firmly; ease off the accelerator; brake gently only when speed has dropped' },
      { id: 'q-vh-6o3', text: 'Accelerate to balance the car' }
    ],
    answerId: 'q-vh-6o2',
    explanation: 'Hold the steering wheel firmly. Ease off the accelerator. Do not brake sharply; brake gently when the vehicle has slowed. Pull off the road when safe.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-7',
    topic: 'General',
    question: 'What is "engine braking"?',
    options: [
      { id: 'q-vh-7o1', text: 'When the engine stops' },
      { id: 'q-vh-7o2', text: 'Using a lower gear to slow the vehicle without using the brakes as much' },
      { id: 'q-vh-7o3', text: 'Putting the car in neutral' }
    ],
    answerId: 'q-vh-7o2',
    explanation: 'Engine braking means changing to a lower gear so the engine helps slow the vehicle. It reduces wear on brakes and helps control speed on downhill or slippery roads.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-8',
    topic: 'General',
    question: 'What should you do if your accelerator sticks?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-8-stuck-accelerator.jpg',
    options: [
      { id: 'q-vh-8o1', text: 'Switch off the engine immediately' },
      { id: 'q-vh-8o2', text: 'Try to free it with your foot; if not, shift to neutral and brake; pull off the road and switch off' },
      { id: 'q-vh-8o3', text: 'Brake hard only' }
    ],
    answerId: 'q-vh-8o2',
    explanation: 'Try to free the pedal. If it stays stuck, shift to neutral, brake, and pull off the road. Switch off the engine when safe.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-9',
    topic: 'General',
    question: 'When driving downhill for a long time, what should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-9-downhill-descent.jpg',
    options: [
      { id: 'q-vh-9o1', text: 'Use the brakes continuously' },
      { id: 'q-vh-9o2', text: 'Use a lower gear and brake in short bursts; avoid riding the brakes' },
      { id: 'q-vh-9o3', text: 'Put the car in neutral' }
    ],
    answerId: 'q-vh-9o2',
    explanation: 'Use a lower gear for engine braking. Brake in short bursts. Avoid holding the brakes on (brake fade and overheating).',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-10',
    topic: 'General',
    question: 'What should you do if you drive through deep water?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-10-deep-water-crossing.jpg',
    options: [
      { id: 'q-vh-10o1', text: 'Drive as fast as possible' },
      { id: 'q-vh-10o2', text: 'Drive slowly and steadily; test brakes afterwards' },
      { id: 'q-vh-10o3', text: 'Use the handbrake to dry the brakes' }
    ],
    answerId: 'q-vh-10o2',
    explanation: 'Drive slowly and steadily through deep water. After leaving the water, test your brakes; they may be less effective until dry.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-11',
    topic: 'General',
    question: 'What is "brake fade"?',
    options: [
      { id: 'q-vh-11o1', text: 'When the brake pedal fades in colour' },
      { id: 'q-vh-11o2', text: 'When brakes overheat and become less effective after prolonged or heavy use' },
      { id: 'q-vh-11o3', text: 'When the brakes make no noise' }
    ],
    answerId: 'q-vh-11o2',
    explanation: 'Brake fade is when brakes overheat (e.g. long downhill braking) and lose effectiveness. Use a lower gear and brake in short bursts to avoid it.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-12',
    topic: 'General',
    question: 'What should you do if your vehicle catches fire?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-12-vehicle-fire.jpg',
    options: [
      { id: 'q-vh-12o1', text: 'Open the bonnet and pour water' },
      { id: 'q-vh-12o2', text: 'Stop safely; get everyone out; call fire service; do not open the bonnet if you suspect engine fire' },
      { id: 'q-vh-12o3', text: 'Drive to the nearest garage' }
    ],
    answerId: 'q-vh-12o2',
    explanation: 'Stop in a safe place. Get everyone out and away from the vehicle. Call the fire service. Do not open the bonnet if there is an engine fire; it can spread.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-13',
    topic: 'General',
    question: 'What should you do if the bonnet flies up while you are driving?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-13-bonnet-flying.jpg',
    options: [
      { id: 'q-vh-13o1', text: 'Speed up to push it down' },
      { id: 'q-vh-13o2', text: 'Ease off; look through the gap or out of the side window; signal and pull off the road safely' },
      { id: 'q-vh-13o3', text: 'Brake hard immediately' }
    ],
    answerId: 'q-vh-13o2',
    explanation: 'Ease off the accelerator. Look through the gap under the bonnet or through the side window. Signal and pull off the road when safe.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-14',
    topic: 'General',
    question: 'When should you use the parking brake (handbrake)?',
    options: [
      { id: 'q-vh-14o1', text: 'Only when parking on a hill' },
      { id: 'q-vh-14o2', text: 'When parking; also in an emergency if the foot brake fails' },
      { id: 'q-vh-14o3', text: 'Never on a modern car' }
    ],
    answerId: 'q-vh-14o2',
    explanation: 'Use the parking brake when you park. You can also use it in an emergency if the foot brake fails (apply gradually).',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-15',
    topic: 'General',
    question: 'What should you do if you are driving and see a warning light for low oil pressure?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-15-low-oil-pressure.jpg',
    options: [
      { id: 'q-vh-15o1', text: 'Continue to your destination' },
      { id: 'q-vh-15o2', text: 'Stop as soon as safe; switch off the engine; do not drive until checked' },
      { id: 'q-vh-15o3', text: 'Add water' }
    ],
    answerId: 'q-vh-15o2',
    explanation: 'Low oil pressure can cause serious engine damage. Stop as soon as it is safe, switch off the engine, and have the vehicle checked.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-16',
    topic: 'General',
    question: 'What is the correct way to brake in an emergency on a dry road?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-16-emergency-braking.jpg',
    options: [
      { id: 'q-vh-16o1', text: 'Pump the brakes gently' },
      { id: 'q-vh-16o2', text: 'Apply the brakes firmly; if the vehicle has ABS, keep firm pressure; if not, you may need to pump to avoid locking' },
      { id: 'q-vh-16o3', text: 'Use the handbrake only' }
    ],
    answerId: 'q-vh-16o2',
    explanation: 'Apply the brakes firmly. With ABS, keep firm pressure and steer. Without ABS, you may need to pump the brakes to avoid locking the wheels.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-17',
    topic: 'General',
    question: 'What should you do if your windscreen fogs up on the inside?',
    options: [
      { id: 'q-vh-17o1', text: 'Wipe it with your hand' },
      { id: 'q-vh-17o2', text: 'Use the demister and open a window slightly if needed' },
      { id: 'q-vh-17o3', text: 'Speed up to clear it' }
    ],
    answerId: 'q-vh-17o2',
    explanation: 'Use the windscreen demister (heater and fan). Opening a window slightly can help clear moisture. Do not drive until you can see clearly.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-18',
    topic: 'General',
    question: 'When driving in strong wind, what should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-18-strong-wind.jpg',
    options: [
      { id: 'q-vh-18o1', text: 'Speed up to stay stable' },
      { id: 'q-vh-18o2', text: 'Slow down; hold the steering firmly; be extra careful when passing high-sided vehicles or on exposed roads' },
      { id: 'q-vh-18o3', text: 'Use the hazard lights' }
    ],
    answerId: 'q-vh-18o2',
    explanation: 'Strong wind can push the vehicle. Slow down, hold the steering firmly, and be careful when passing lorries or on bridges and open roads.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-19',
    topic: 'General',
    question: 'What should you do if you have a puncture while driving?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-19-puncture-emergency.jpg',
    options: [
      { id: 'q-vh-19o1', text: 'Brake hard and stop immediately' },
      { id: 'q-vh-19o2', text: 'Hold the steering firmly; ease off the accelerator; pull off the road when safe' },
      { id: 'q-vh-19o3', text: 'Accelerate to the nearest garage' }
    ],
    answerId: 'q-vh-19o2',
    explanation: 'Hold the steering wheel firmly. Ease off the accelerator. Do not brake sharply. Pull off the road when it is safe to do so.',
    subject: 'Vehicle Handling'
  },
  {
    id: 'q-vh-20',
    topic: 'General',
    question: 'What does ABS (Anti-lock Braking System) allow you to do when braking hard?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-20-abs-indicator.jpg',
    options: [
      { id: 'q-vh-20o1', text: 'Stop in a shorter distance on all surfaces' },
      { id: 'q-vh-20o2', text: 'Brake hard and still steer; the wheels are prevented from locking' },
      { id: 'q-vh-20o3', text: 'Brake without using the pedal' }
    ],
    answerId: 'q-vh-20o2',
    explanation: 'ABS prevents the wheels from locking under heavy braking so you can steer. Apply firm pressure and steer; do not pump the brakes.',
    subject: 'Vehicle Handling'
  },
];
